import _ from 'lodash';

import { list, categoryValues } from './tags';

function endpoints(builder) {
  return {
    getArtObjectCategoryValues: builder.query({
      query: (participationId) => `tefaf/exhibitorportal/art-object/get-category-values/${participationId}`,
      providesTags: categoryValues,
    }),
    getArtObjects: builder.query({
      query: (participationId) => `tefaf/exhibitorportal/art-object/list/${participationId}`,
      providesTags: list,
    }),
    createArtObject: builder.mutation({
      invalidatesTags: list,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', values.action);
        body.append('participationId', values.participationId);
        if (values.artObjectId) {
          body.append('artObjectId', values.artObjectId);
        }
        if (Object.hasOwn(values, 'artObjectTitle')) {
          body.append('fields[artObjectTitle]', values.artObjectTitle);
        }
        if (Object.hasOwn(values, 'artObjectAttribution')) {
          body.append('fields[artObjectAttribution]', values.artObjectAttribution);
        }
        if (Object.hasOwn(values, 'artObjectPrimaryArtistFirstName')) {
          body.append('fields[artObjectPrimaryArtistFirstName]', values.artObjectPrimaryArtistFirstName);
        }
        if (Object.hasOwn(values, 'artObjectPrimaryArtistLastName')) {
          body.append('fields[artObjectPrimaryArtistLastName]', values.artObjectPrimaryArtistLastName);
        }
        if (Object.hasOwn(values, 'artObjectYear')) {
          body.append('fields[artObjectYear]', values.artObjectYear);
        }
        if (Object.hasOwn(values, 'artObjectCategories')) {
          _.forEach(values.artObjectCategories, (category) => {
            body.append('fields[artObjectCategories][]', category);
          });
        }
        if (Object.hasOwn(values, 'artObjectPrimaryArtistYearOfBirth')) {
          body.append('fields[artObjectPrimaryArtistYearOfBirth]', values.artObjectPrimaryArtistYearOfBirth);
        }
        if (Object.hasOwn(values, 'artObjectPrimaryArtistPlaceOfBirth')) {
          body.append('fields[artObjectPrimaryArtistPlaceOfBirth]', values.artObjectPrimaryArtistPlaceOfBirth);
        }
        if (Object.hasOwn(values, 'artObjectPrimaryArtistYearOfDeath')) {
          body.append('fields[artObjectPrimaryArtistYearOfDeath]', values.artObjectPrimaryArtistYearOfDeath);
        }
        if (Object.hasOwn(values, 'artObjectPrimaryArtistPlaceOfDeath')) {
          body.append('fields[artObjectPrimaryArtistPlaceOfDeath]', values.artObjectPrimaryArtistPlaceOfDeath);
        }
        if (Object.hasOwn(values, 'artObjectImages')) {
          _.forEach(values.artObjectImages, (file) => {
            body.append('fields[artObjectImages][]', (_.isObject(file) && file.id ? file.id : file));
          });
        }
        if (Object.hasOwn(values, 'artObjectImagesCaption')) {
          _.forEach(values.artObjectImagesCaption, (caption) => {
            body.append('fields[artObjectImagesCaption][]', caption);
          });
        }
        if (Object.hasOwn(values, 'tefafOnlinePlatform')) {
          body.append('fields[tefafOnlinePlatform]', values.tefafOnlinePlatform);
        }
        if (Object.hasOwn(values, 'generalPressAndMarketing')) {
          body.append('fields[generalPressAndMarketing]', values.generalPressAndMarketing);
        }
        if (Object.hasOwn(values, 'approvedForAdvertisingUse')) {
          body.append('fields[approvedForAdvertisingUse]', values.approvedForAdvertisingUse);
        }
        if (Object.hasOwn(values, 'artObjectApproveCollections')) {
          body.append('fields[artObjectApproveCollections]', values.artObjectApproveCollections);
        }
        if (Object.hasOwn(values, 'artObjectPermissionsSet')) {
          body.append('fields[artObjectPermissionsSet]', values.artObjectPermissionsSet);
        }
        if (Object.hasOwn(values, 'artObjectMaterial')) {
          body.append('fields[artObjectMaterial]', values.artObjectMaterial);
        }
        if (Object.hasOwn(values, 'artObjectMeasurements')) {
          body.append('fields[artObjectMeasurements]', values.artObjectMeasurements);
        }
        if (Object.hasOwn(values, 'artObjectLocation')) {
          body.append('fields[artObjectLocation]', values.artObjectLocation);
        }
        if (Object.hasOwn(values, 'artObjectPeriod')) {
          body.append('fields[artObjectPeriod][]', values.artObjectPeriod ? [values.artObjectPeriod] : []);
        }
        if (Object.hasOwn(values, 'artObjectCopyright')) {
          body.append('fields[artObjectCopyright]', values.artObjectCopyright);
        }
        if (Object.hasOwn(values, 'artObjectProvenance')) {
          body.append('fields[artObjectProvenance]', (values.artObjectProvenance || ''));
        }
        if (Object.hasOwn(values, 'artObjectAboutArtwork')) {
          body.append('fields[artObjectAboutArtwork]', (values.artObjectAboutArtwork || ''));
        }
        if (Object.hasOwn(values, 'artObjectAboutArtworkHistoricalInformation')) {
          body.append('fields[artObjectAboutArtworkHistoricalInformation]', (values.artObjectAboutArtworkHistoricalInformation || ''));
        }
        if (Object.hasOwn(values, 'artObjectAboutArtworkCollectors')) {
          body.append('fields[artObjectAboutArtworkCollectors]', (values.artObjectAboutArtworkCollectors || ''));
        }
        if (Object.hasOwn(values, 'artObjectLiterature')) {
          body.append('fields[artObjectLiterature]', '');
          _.forEach(
            _.filter(values.artObjectLiterature, (({ publicationDescription: p }) => !!p)),
            ({
              id,
              publicationType,
              publicationDescription,
            }) => {
              body.append('fields[artObjectLiterature][sortOrder][]', id);
              body.append(`fields[artObjectLiterature][entries][${id}][enabled]`, '1');
              body.append(`fields[artObjectLiterature][entries][${id}][type]`, 'literatureSimple');
              body.append(`fields[artObjectLiterature][entries][${id}][fields][publicationType]`, (publicationType || 'Other'));
              body.append(`fields[artObjectLiterature][entries][${id}][fields][publicationDescription]`, (publicationDescription || ''));
            },
          );
        }
        if (Object.hasOwn(values, 'artObjectPriceBracket')) {
          body.append('fields[artObjectPriceBracket][]', values.artObjectPriceBracket ? [values.artObjectPriceBracket] : []);
        }
        if (Object.hasOwn(values, 'artObjectPrice')) {
          body.append('fields[artObjectPrice]', (values.artObjectPrice || ''));
        }

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
    requestEditArtObject: builder.mutation({
      invalidatesTags: list,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', values.action);
        body.append('participationId', values.participationId);
        body.append('artObjectId', values.artObjectId);
        body.append('message', values.message);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
    deleteDraftArtObject: builder.mutation({
      invalidatesTags: list,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'tefaf/exhibitorportal/art-object/delete-draft');
        body.append('participationId', values.participationId);
        body.append('artObjectId', values.artObjectId);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
  };
}

export { endpoints };
